module.exports = __webpack_public_path__ + "static/media/icon_delete.22680712.svg";